<!--
 * @Author: Zheng Lei
 * @Email: baimoc@163.com
 * @Date: 2021-03-03 10:49:23
 * @LastEditTime: 2022-04-22 18:38:18
 * @FilePath: \raacfold\src\components\raacview\RaacView.vue
-->
<template>
    <div >
        <div class="raac-seq" style="margin: 5px 0px 5px -1px;">
            <span v-for="(clu, index) in clusters" class="seq" :style="{background: clusters_colors[index], color: '#FFFFFF'}" style="color: #57606f" :key="index">{{clu}}</span>
        </div>
           
    </div>
</template>

<script>
    export default {
        data() {
            return {          
                clusters:[],
            };
        },
        props: {
        },
        watch: {   
            "$store.state.raac_scheme"() {
                this.clusters = this.$store.state.raac_scheme;
            },
            "$store.state.raac_color"() {
                // console.log("$store.state.raac_color", this.$store.state.raac_color)
                this.clusters_colors = this.$store.state.raac_color;
                this.clusters.push("");
                this.clusters.pop();
            },
        },
        components: {},
        mounted() {
            this.clusters = this.$store.state.raac_scheme;
            // this.setColor();
        },
        methods: {
        },
    };

</script>

<style>
    .el-dropdown-menu__item {
        line-height: 24px !important;
        padding: 0 10px !important;
        font-size: 12px !important;
        font-family: "OpenSans-Semibold", "Helvetica Neue", Helvetica, Arial,
        sans-serif !important;
        
    }
    .el-dropdown-menu__item:hover {
        background: #ecf0f1 !important;
        color: #2f3542 !important;
    }
    .el-dropdown-menu__item--divided:before {
        height: 0px !important;
        margin: 0px !important;
    }
    .el-dropdown-menu__item--divided {
        position: relative;
        margin-top: 0px !important;
        border-top: 1px solid #EBEEF5;
    }
    .el-dropdown-menu {
        position: absolute;
        top: 0;
        left: 0;
        padding: 0px !important;
        margin: 5px 0;
        background-color: #FFF;
        border: 0px solid #EBEEF5 !important;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgb(0 0 0 / 10%);
        opacity: 0.95 !important;
    }
    
    .raac-bar {
        background: #dfe4ea;
        height: 30px;
        white-space: nowrap;
        overflow: hidden;
        /*width: 330px;*/
        /*border-radius: 10px;*/
        margin-bottom: 2px;
    }

    .raac-num {
        background: rgba(64, 158, 255, 1);
        text-shadow: #404040 0px 1px 2px;
        width: 30px;
        height: 30px;
        float: left;
        text-align: center;
        font-size: 16px;
        color: #f6f5f3;
        padding-top: 3px;
        /*border-radius: 0px 10px 0px 10px;*/
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .raac-seq {
        background: transparent;
        height: 30px;
        /*width: 210px;*/
        float: left;
        padding-left: 10px;
        padding-top: 5px;
    }

    .raac-color-picker {
        background:  transparent;
        width: 30px;
        height: 30px;
        float: right;
        padding: 5px;
        border-left: 0.2px solid #f1f2f6;
        border-right: 1px solid #d1d8e0;
        border-radius: 0px 5px 5px 0px;
    }

    .raac-show {
        background: transparent;
        width: 30px;
        height: 30px;
        float: right;
        border-top: 1px solid #E0DDD4;
        border-bottom: 1px solid #E0DDD4;
        border-left: 1px solid #b1becd;
    }
    bm {
    }
    .raac-bar:hover {
        background: #ced6e0;
        /*cursor: pointer;*/
    }
    .bm-aside {
        margin: 0px;
        padding: 0px;
        background-color: #f1f2f6;
        border-right: 1px solid #e1e3e7
    }

    .bm-hr {
        border: 0.5px solid #ced6e0 !important;
    }


    .bm .el-color-picker {
        height: 30px;
    }

    .bm .el-color-picker__color-inner {
        border-radius: 4px;
    }

    .bm .el-color-picker__icon {
        visibility: hidden;
    }

    .bm .el-color-picker__trigger {
        height: 18px ;
        width: 18px ;
        padding: 0px;
        border: none;
        /*border-top: 1px solid #E0DDD4;*/
        /*border-bottom: 1px solid #E0DDD4;*/
    }

    .bm .el-color-picker__color {
        border: none;
    }

    .bm .el-dropdown {
        /*color: transparent;*/
        padding: 2px 6px;
        font-size: 18px;
        color: #332B1F;
    }

    iframe {
        height: 1200px;
        border-width: 0px;
        padding: 0px;
    }

    /*//-----------------------------*/
    .a {
        background: #f3a683;
        padding: 3px;
    }

    .b {
        background: #8e44ad;
        padding: 3px;
    }

    .c {
        background: #cf6a87;
        padding: 3px;
    }

    .d {
        background: #e77f67;
        padding: 3px;
    }

    .e {
        background: #f5cd79;
        padding: 3px;
    }

    .f {
        background: #ea8685;
        padding: 3px;
    }

    .g {
        background: #546de5;
        padding: 3px;
    }

    .h {
        background: #e15f41;
        padding: 3px;
    }

    .i {
        background: #c44569;
        padding: 3px;
    }

    .k {
        background: #f8a5c2;
        padding: 3px;
    }


    .l {
        background: #786fa6;
        padding: 3px;
    }

    .m {
        background: #63cdda;
        padding: 3px;
    }

    .n {
        background: #778beb;
        padding: 3px;
    }

    .p {
        background: #596275;
        padding: 3px;
    }

    .q {
        background: #f19066;
        padding: 3px;
    }


    .r {
        background: #f7d794;
        padding: 3px;
    }

    .s {
        background: #574b90;
        padding: 3px;
    }

    .t {
        background: #f78fb3;
        padding: 3px;
    }

    .u {
        background: #34495e;
        padding: 3px;
    }

    .v {
        background: #303952;
        padding: 3px;
    }

    .w {
        background: #3dc1d3;
        padding: 3px;
    }

    .y {
        background: #e66767;
        padding: 3px;
    }

    .z {
        background: #95a5a6;
        padding: 3px;
    }

    .x {
        background: #bdc3c7;
        padding: 3px;
    }


    .A {
        background: #f3a683;
        padding: 3px;
    }

    .B {
        background: #8e44ad;
        padding: 3px;
    }

    .C {
        background: #cf6a87;
        padding: 3px;
    }

    .D {
        background: #e77f67;
        padding: 3px;
    }

    .E {
        background: #f5cd79;
        padding: 3px;
    }

    .F {
        background: #ea8685;
        padding: 3px;
    }

    .G {
        background: #546de5;
        padding: 3px;
    }

    .H {
        background: #e15f41;
        padding: 3px;
    }

    .I {
        background: #c44569;
        padding: 3px;
    }

    .K {
        background: #f8a5c2;
        padding: 3px;
    }


    .L {
        background: #786fa6;
        padding: 3px;
    }

    .M {
        background: #63cdda;
        padding: 3px;
    }

    .N {
        background: #778beb;
        padding: 3px;
    }

    .P {
        background: #596275;
        padding: 3px;
    }

    .Q {
        background: #f19066;
        padding: 3px;
    }


    .R {
        background: #f7d794;
        padding: 3px;
    }

    .S {
        background: #574b90;
        padding: 3px;
    }

    .T {
        background: #f78fb3;
        padding: 3px;
    }

    .U {
        background: #34495e;
        padding: 3px;
    }

    .V {
        background: #303952;
        padding: 3px;
    }

    .W {
        background: #3dc1d3;
        padding: 3px;
    }

    .Y {
        background: #e66767;
        padding: 3px;
    }

    .Z {
        background: #95a5a6;
        padding: 3px;
    }

    .X {
        background: #bdc3c7;
        padding: 3px;
    }

    /*.- {*/
        /*background: #ecf0f1;*/
        /*padding: 3px;*/
    /*}*/

    /*.* {*/
        /*background: #2f3640;*/
        /*padding: 3px;*/
    /*}*/

    .eq {
        background: #f3a683;
        padding: 3px;
    }

    .ad {
        background: #f7d794;
        padding: 3px;
    }

    .re {
        background: #778beb;
        padding: 3px;
    }

    .eq {
        background: #e77f67;
        padding: 3px;
    }

    .ad {
        background: #cf6a87;
        padding: 3px;
    }

    .re {
        background: #f19066;
        padding: 3px;
    }

    .alpha {
        background: #f5cd79;
        padding: 3px;
    }

    .beta {
        background: #546de5;
        padding: 3px;
    }

    .seq {
        width: 22px;
        /*letter-spacing:6px;*/
        font-family: Monaco, Consolas, monospace;
        color: #FFFFFF;
        font-size: 16px;
        letter-spacing: 2px;
        /*font-weight: bold;*/
        -moz-user-select: none;
        -webkit-user-select: none;
        -ms-user-select: none;
        user-select: none;
        padding: 3px
    }

    /*.seq {*/
    /*width: 22px;*/
    /*!*letter-spacing:6px;*!*/
    /*font-family: Monaco, Consolas, monospace;*/
    /*color: white;*/
    /*text-shadow: 1px 1px 1px #000;*/
    /*font-size: 21px;*/
    /*white-space:no-wrap;*/
    /*moz-user-select: -moz-none;*/
    /*-moz-user-select: none;*/
    /*-o-user-select:none;*/
    /*-khtml-user-select:none;*/
    /*-webkit-user-select:none;*/
    /*-ms-user-select:none;*/
    /*user-select:none;*/
    /*}*/

    .seq-num {
        width: 22px;
        font-family: Monaco, Consolas, monospace;
        font-size: 20px;
        padding: 3px;
    }

    .seq-num a {
        text-decoration: none;
    }

    .seq-line {
        width: 22px;
        font-family: Monaco, Consolas, monospace;
        font-size: 20px;
        padding: 3px;
    }


    .seq-div {
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .seq-download {
        color: #666666;
        height: 22px;
        width: 38px;
        float: right;
    }

    .seq-title {
        color: #333333;
        font-size: 18px;
        margin: 8px;
        text-align: center;
    }
</style>
